
import React from 'react';
import './loadingBanner.scss';

/**
 * The LoadingBanner component.
 *
 * @constructor
 */
export class LoadingBanner extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div className="loading-banner callout primary">
        <div className="spinner" />
        <h2>Loading...</h2>
        <p>
          <span className="inline-text">
            Please wait while the data is loading.
          </span>
        </p>
      </div>
    );
  }
}

LoadingBanner.propTypes = {};

export default LoadingBanner;



// WEBPACK FOOTER //
// ./src/components/common/loadingBanner/LoadingBanner.js